// extracted by mini-css-extract-plugin
export default {"Emoji":"bbn_a bho_i bho_q bho_j"};